export default {
    type: 'Work space',
    submit: 'Save',
    abort: 'Cancel',
    title: {
        label: 'Title',
        error: 'Please enter a title for the work space'
    },
    description: {
        label: 'Description',
        error: 'Please enter a description for the work space'
    },
    private: {
        label: 'Private',
        tooltip: {
            private: 'Private: Only you and participants who add you to this workshop can access the content.',
            public: 'Public: Every user in your company can access your worksapce, add themselves as a participant and edit it.'
        }
    },
    user: {
        label: 'Participants'
    }
}
